import { createToggleStore } from '@/lib/utils/createToggleStore';

export const useHighContrastMode = createToggleStore(false, 'highContrastMode');

export const useLargeTextMode = createToggleStore(false, 'largeTextMode');

export const useReadingMode = createToggleStore(false, 'readingMode');
